module.exports = __webpack_public_path__ + "img/polisre.3b77a56f.svg";